import { Action } from 'redux';

export interface ILoginAction<T, P = any> extends Action<T> {
  payload: P;
}

export const APP_LOGIN_SHOW = 'APP_LOGIN_SHOW';
export type APP_LOGIN_SHOW = typeof APP_LOGIN_SHOW;
export interface IShowLoginAction extends Action<APP_LOGIN_SHOW> {
  type: APP_LOGIN_SHOW;
}

export const APP_LOGIN_EMAIL_UPDATE = 'APP_LOGIN_EMAIL_UPDATE';
export type APP_LOGIN_EMAIL_UPDATE = typeof APP_LOGIN_EMAIL_UPDATE;
export interface IUpdateEmailAction extends ILoginAction<APP_LOGIN_EMAIL_UPDATE> {
  type: APP_LOGIN_EMAIL_UPDATE;
  payload: { email: string };
}

export const APP_LOGIN_PASSWORD_UPDATE = 'APP_LOGIN_PASSWORD_UPDATE';
export type APP_LOGIN_PASSWORD_UPDATE = typeof APP_LOGIN_PASSWORD_UPDATE;
export interface IUpdatePasswordAction extends ILoginAction<APP_LOGIN_PASSWORD_UPDATE> {
  type: APP_LOGIN_PASSWORD_UPDATE;
  payload: { password: string };
}

export const APP_LOGIN_SUBMIT = 'APP_LOGIN_SUBMIT';
export type APP_LOGIN_SUBMIT = typeof APP_LOGIN_SUBMIT;
export interface ISubmitAction extends Action<APP_LOGIN_SUBMIT> {
  type: APP_LOGIN_SUBMIT;
}

export const APP_LOGIN_SUCCESS = 'APP_LOGIN_SUCCESS';
export type APP_LOGIN_SUCCESS = typeof APP_LOGIN_SUCCESS;
export interface ISuccessAction extends Action<APP_LOGIN_SUCCESS> {
  type: APP_LOGIN_SUCCESS;
}

export interface IFormError {
  field: string;
  error: string;
}

export const APP_LOGIN_ERROR = 'APP_LOGIN_ERROR';
export type APP_LOGIN_ERROR = typeof APP_LOGIN_ERROR;
export interface IErrorAction extends ILoginAction<APP_LOGIN_ERROR> {
  type: APP_LOGIN_ERROR;
  payload: { error: IFormError };
}

export const APP_LOGIN_ERROR_CLEAN = 'APP_LOGIN_ERROR_CLEAN';
export type APP_LOGIN_ERROR_CLEAN = typeof APP_LOGIN_ERROR_CLEAN;
export interface IErrorCleanAction extends ILoginAction<APP_LOGIN_ERROR_CLEAN> {
  type: APP_LOGIN_ERROR_CLEAN;
  payload: { field: string };
}

export type ILoginActions =
  | IShowLoginAction
  | IUpdateEmailAction
  | IUpdatePasswordAction
  | ISubmitAction
  | IErrorAction
  | IErrorCleanAction
  | ISuccessAction;
